module.exports = __webpack_public_path__ + "img/the-long-ball-logo.f4a89a3e.svg";